import { has } from 'lodash-es'

export default function genExposeName(tmpl, countPlh = ':count:') {
  let count = 0
  let freeName
  do {
    const name = tmpl.replace(countPlh, count)
    if (!has(window, name)) {
      freeName = name
    } else {
      count++
    }
  } while (!freeName)

  return freeName
}
